'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import React, { useState } from 'react';
import { getRegionalUrl } from '@/lib/utils';

interface ProductCardProps {
  title: string;
  handle: string;
  thumbnail: string;
  rrp: string;
}

const SuggestionCard = ({
  item,
  layout,
  onClick,
}: {
  item: ProductCardProps;
  layout: number;
  onClick?: () => void;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const params = useParams<{ countryCode?: string }>();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <Link
      href={getRegionalUrl(`/product/${item?.handle}`, params?.countryCode)}
      onClick={onClick}
    >
      <div
        className="sm:max-w-xs relative w-full h-full group overflow-hidden pb-5 flex flex-col cursor-pointer transition-all  duration-200 justify-between rounded-[10px] md:hover:bg-white md:hover:shadow-md hover:shadow-black/30  bg-off-white"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          id="borderElement"
          className={`w-full h-full   absolute top-0 bottom-0 left-0 right-0 md:hover:border-[2px] ${
            isHovered ? 'md:border-[2px]' : ''
          }  rounded-[10px]`}
        ></div>
        <div className="flex items-center flex-col justify-start gap-2 h-full px-4 pt-4">
          {item?.thumbnail ? (
            <div className="relative w-full aspect-square rounded-lg overflow-hidden flex items-center justify-center">
              <Image
                alt=""
                fill
                loading="lazy"
                className={`h-full w-full`}
                src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${item?.thumbnail}`}
              />
            </div>
          ) : (
            <div className="col-span-2 w-full aspect-square flex flex-col gap-1 items-center opacity-50 justify-center">
              <Image
                src={'/assets/loader/no-image.png'}
                width={200}
                height={200}
                className="w-7 h-7"
                alt="img"
              />
              <p className="font-proxima_font text-sm">No Image</p>
            </div>
          )}
          <div
            className={` w-full h-auto  py-2 flex flex-col gap-1 text-center items-center justify-between`}
          >
            <h1 className="font-semibold  font-proxima_font text-center text-black text-[14px] md:text-[18px]">
              {item?.title}
            </h1>
            <h1 className="product-price md:font-semibold text-center font-bold font-proxima_font text-black text-[18px] md:text-[16px]">
              ${item?.rrp}
            </h1>
          </div>
          <div className="flex justify-center mt-auto w-full">
            <div
              onMouseEnter={handleMouseEnter}
              className={`w-full flex items-center justify-center ${layout === 2 ? 'hidden' : ''}  mx-auto`}
            >
              <button
                onMouseEnter={handleMouseEnter}
                className=" py-2 px-6 mt-2 w-full rounded-xl group-hover:opacity-80 font-semibold font-proxima_font text-[14px] border transition-all duration-200 bg-black text-white border-black "
              >
                Explore
              </button>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SuggestionCard;
